import { useRef, useState } from 'react'
import ImageInput from '../../../core/components/UI/ImageInput'
import { useNavigate } from 'react-router-dom/dist/umd/react-router-dom.development'
import useMineralsActions from '../../hooks/useMineralsActions'
import { toastSuccess } from '../../../helper'
import { FaSpinner } from 'react-icons/fa'

export default function FormMineralValueChainEdit({ mineral }) {
  const navigate = useNavigate()

  const { updateMineralValueChain, inProgress } = useMineralsActions()
  const [mineralValueChainArImage, setMineralValueChainArImage] = useState(null)
  const [mineralValueChainEnImage, setMineralValueChainEnImage] = useState(null)
  const mineralValueChainArSourceRef = useRef(null)
  const mineralValueChainEnSourceRef = useRef(null)
  const mineralValueChainLinkRef = useRef(null)

  async function handleOnSubmitCreateMineralForm(event) {
    event.preventDefault()
    const payload = {
      image_ar: mineralValueChainArImage,
      image_en: mineralValueChainEnImage,
      source_ar: mineralValueChainArSourceRef.current?.value,
      source_en: mineralValueChainEnSourceRef.current?.value,
      link: mineralValueChainLinkRef.current?.value,
    }
    console.log(payload)

    const message = await updateMineralValueChain(mineral.id, payload)
    if (message) {
      toastSuccess(message)
      navigate(`/minerals`)
    }
  }

  return (
    <form
      onSubmit={handleOnSubmitCreateMineralForm}
      className="flex flex-col gap-4"
    >
      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_IMAGE_AR"
          >
            صورة سلسلة القيمة بالعربية<span className="text-danger-600">*</span>
          </label>
          <ImageInput
            id={'ID_MINERAL_IMAGE_AR'}
            onChange={(image) => setMineralValueChainArImage(image)}
            className={'h-96 w-full'}
            defaultValue={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral?.value_chain?.image_ar}`}
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_IMAGE_EN"
          >
            صورة سلسلة القيمة بالإنجليزية
          </label>
          <ImageInput
            id={'ID_MINERAL_IMAGE_EN'}
            onChange={(image) => setMineralValueChainEnImage(image)}
            className={'h-96 w-full'}
            defaultValue={`${process.env.REACT_APP_API_BASE_URL}/storage/minerals/${mineral?.value_chain?.image_en}`}
          />
        </div>
      </div>

      <div className="flex gap-4">
        <div className="flex w-full flex-col gap-1">
          <label
            className="line-clamp-1 font-bold"
            htmlFor="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
          >
            اسم مصدر بالعربية
          </label>
          <input
            id="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
            ref={mineralValueChainArSourceRef}
            defaultValue={mineral?.value_chain?.source_ar}
            type="text"
            className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
          />
        </div>
        <div className="flex w-full flex-col gap-1">
          <label
            className="font-bold"
            htmlFor="ID_MINERAL_VALUE_CHAIN_EN_SOURCE"
          >
            اسم مصدر بالإنجليزية
          </label>
          <input
            dir="ltr"
            id="ID_MINERAL_VALUE_CHAIN_EN_SOURCE"
            ref={mineralValueChainEnSourceRef}
            defaultValue={mineral?.value_chain?.source_en}
            type="text"
            className="border-2 border-muted-500 px-4 py-2 leading-none outline-none"
          />
        </div>
      </div>
      <div className="flex w-full flex-col gap-1">
        <label
          className="line-clamp-1 font-bold"
          htmlFor="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
        >
          رابط المصدر
        </label>
        <input
          dir="ltr"
          id="ID_MINERAL_VALUE_CHAIN_AR_SOURCE"
          ref={mineralValueChainLinkRef}
          defaultValue={mineral?.value_chain?.link}
          type="text"
          className="border-2 border-muted-500 px-3 py-2 leading-none outline-none"
        />
      </div>
      <button
        type="submit"
        disabled={inProgress}
        className="flex w-full items-center justify-center gap-2 border-2 border-primary-600 bg-primary-600 px-6 py-3 font-bold text-white outline-none hover:border-accent-600 hover:bg-accent-600 disabled:cursor-not-allowed disabled:border-muted-500 disabled:bg-muted-300 disabled:text-primary-600"
      >
        {inProgress ? (
          <>
            <FaSpinner
              size={16}
              className="animate-spin"
            />
            <span>جاري تعديل سلسلة القيمة...</span>
          </>
        ) : (
          <span>تعديل سلسلة القيمة</span>
        )}
      </button>
    </form>
  )
}
